var _path, _polygon, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEbook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-124"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.12,
    y: 283.66,
    width: 26.3,
    height: 45.33,
    transform: "translate(391.59 221.06) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.97,
    y: 354.16,
    width: 20.77,
    height: 56.58,
    transform: "translate(462.82 302.1) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.15,393.08c.18,0,.32-4.75.32-10.6s-.14-10.61-.32-10.61-.31,4.75-.31,10.61S56,393.08,56.15,393.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.84,391.93c.17,0,.31-4.49.31-10s-.14-10-.31-10-.32,4.49-.32,10S58.66,391.93,58.84,391.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.49,383.05c0-.17-7.49-.32-16.74-.32s-16.74.15-16.74.32,7.5.32,16.74.32S97.49,383.22,97.49,383.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.67,392.84c.17,0,.31-4.55.31-10.17s-.14-10.16-.31-10.16-.32,4.55-.32,10.16S102.5,392.84,102.67,392.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.1,392.84c.17,0,.31-4.67.31-10.42S105.27,372,105.1,372s-.32,4.66-.32,10.42S104.92,392.84,105.1,392.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.96,
    y: 332.39,
    width: 16.68,
    height: 62.7,
    transform: "translate(441.04 286.44) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.75,372.19a15.52,15.52,0,0,0,2.13-2.3c1.25-1.48,2.93-3.57,4.72-5.92S85,359.44,86,357.84a15.09,15.09,0,0,0,1.65-2.67,15.61,15.61,0,0,0-2,2.41l-4.58,6-4.57,6A15.56,15.56,0,0,0,74.75,372.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.93,372.26c.13.12,3.44-3.52,7.38-8.12s7-8.43,6.9-8.54-3.44,3.52-7.38,8.13S64.8,372.15,64.93,372.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.84,
    y: 410.74,
    width: 7.98,
    height: 59.73,
    transform: "translate(519.43 361.77) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1,444.26c.21,0,.38-1.67.38-3.74s-.17-3.73-.38-3.73-.38,1.67-.38,3.73S56.89,444.26,57.1,444.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8,444.43c.21,0,.38-1.68.38-3.74S56,437,55.8,437s-.38,1.67-.38,3.74S55.59,444.43,55.8,444.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.08,444.26c.2,0,.37-1.67.37-3.74s-.17-3.73-.37-3.73-.38,1.67-.38,3.73S103.87,444.26,104.08,444.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.78,444.43c.2,0,.37-1.68.37-3.74S103,437,102.78,437s-.38,1.67-.38,3.74S102.57,444.43,102.78,444.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,440.36c0-.21-6.84-.37-15.27-.37s-15.29.16-15.29.37,6.85.38,15.29.38S95,440.57,95,440.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.47,
    y: 370.99,
    width: 15.96,
    height: 59.73,
    transform: "translate(479.3 322.41) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.08,397.36l-.33-.18c-.21-.12-.55-.27-1-.46a17.4,17.4,0,0,0-4.05-1.16,10.59,10.59,0,0,0-6.57.94A8.68,8.68,0,0,0,94,399.32a6.57,6.57,0,0,0-1.09,4.6A4.82,4.82,0,0,0,94,406.3a3.14,3.14,0,0,0,2.52,1.14,3.62,3.62,0,0,0,2.53-1.36,5,5,0,0,0,1.15-2.72,7.23,7.23,0,0,0-2-5.66,9.14,9.14,0,0,0-5.74-2.81,15.29,15.29,0,0,0-6.67.83A12.27,12.27,0,0,0,80,399.63a6.44,6.44,0,0,0-1.36,3.45,4.47,4.47,0,0,0,1.27,3.58,2.89,2.89,0,0,0,1.87.82,3.35,3.35,0,0,0,2-.55,5.17,5.17,0,0,0,2.19-3.22,7.53,7.53,0,0,0-2.35-7A11.78,11.78,0,0,0,76.8,394a16.5,16.5,0,0,0-7,.68,9.63,9.63,0,0,0-5.3,4.13,7,7,0,0,0-.67,6.34,3.35,3.35,0,0,0,2.44,2.06,3.86,3.86,0,0,0,3-.73,5,5,0,0,0,1.42-5.38,9.31,9.31,0,0,0-3-4.24,13.55,13.55,0,0,0-8.19-3.18A13.14,13.14,0,0,0,53,395.11a12.74,12.74,0,0,0-3.38,2.5c-.33.36-.57.63-.72.83a1.37,1.37,0,0,0-.21.31,15.46,15.46,0,0,1,4.44-3.38,12.91,12.91,0,0,1,6.34-1.32,13.18,13.18,0,0,1,7.87,3.17,8.83,8.83,0,0,1,2.8,4,4.4,4.4,0,0,1-1.25,4.71,3.21,3.21,0,0,1-2.51.6,2.69,2.69,0,0,1-2-1.7,6.44,6.44,0,0,1,.65-5.72,9,9,0,0,1,4.94-3.8,15.82,15.82,0,0,1,6.66-.63A11.06,11.06,0,0,1,83,397.24a6.79,6.79,0,0,1,2.12,6.3,4.45,4.45,0,0,1-1.86,2.76,2.29,2.29,0,0,1-2.91-.18,3.71,3.71,0,0,1-1-3,5.63,5.63,0,0,1,1.21-3.05A11.59,11.59,0,0,1,86,396.4a14.57,14.57,0,0,1,6.35-.82,8.41,8.41,0,0,1,5.34,2.57,6.61,6.61,0,0,1,1.93,5.14c-.15,1.75-1.49,3.47-3.1,3.57a2.55,2.55,0,0,1-2.08-.93,4.39,4.39,0,0,1-1-2.1,6.11,6.11,0,0,1,1-4.25,8.29,8.29,0,0,1,2.92-2.72,10.35,10.35,0,0,1,6.33-1,19,19,0,0,1,4,1C108.6,397.19,109.07,397.39,109.08,397.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.29,
    y: 395.7,
    width: 27.69,
    height: 54.4,
    transform: "translate(504.03 341.76) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,435.79c.21,0,.37-6,.37-13.4S63.19,409,63,409s-.38,6-.38,13.4S62.77,435.79,63,435.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1,436.13c.21,0,.38-5.92.38-13.23s-.17-13.23-.38-13.23-.37,5.93-.37,13.23S66.89,436.13,67.1,436.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.19,437c.21,0,.37-6.23.37-13.93s-.16-13.93-.37-13.93-.38,6.24-.38,13.93S102,437,102.19,437Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.34,436.65c.21,0,.38-6.08.38-13.57s-.17-13.58-.38-13.58S97,415.58,97,423.08,97.13,436.65,97.34,436.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.08,
    y: 317.57,
    width: 15.96,
    height: 59.73,
    transform: "translate(425.5 269.37) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7,343.94l-.33-.18c-.22-.12-.55-.27-1-.46a17.91,17.91,0,0,0-4-1.16,10.62,10.62,0,0,0-6.58.94,8.79,8.79,0,0,0-3.12,2.83,6.58,6.58,0,0,0-1.08,4.59,4.8,4.8,0,0,0,1.09,2.38A3.16,3.16,0,0,0,96.16,354a3.61,3.61,0,0,0,2.54-1.36,5,5,0,0,0,1.15-2.72,7.2,7.2,0,0,0-2.06-5.66,9.09,9.09,0,0,0-5.74-2.81,15.24,15.24,0,0,0-6.66.83,12.34,12.34,0,0,0-5.82,3.91,6.39,6.39,0,0,0-1.36,3.45,4.47,4.47,0,0,0,1.27,3.59,2.94,2.94,0,0,0,1.87.82,3.49,3.49,0,0,0,2-.55,5.21,5.21,0,0,0,2.2-3.22,7.52,7.52,0,0,0-2.35-7,11.73,11.73,0,0,0-6.73-2.74,16.65,16.65,0,0,0-7,.68,9.63,9.63,0,0,0-5.3,4.13,7,7,0,0,0-.67,6.34,3.33,3.33,0,0,0,2.44,2.06,3.87,3.87,0,0,0,3-.73,5,5,0,0,0,1.42-5.37,9.28,9.28,0,0,0-3-4.25,13.65,13.65,0,0,0-8.19-3.18,13.27,13.27,0,0,0-9.88,4,8.27,8.27,0,0,0-.71.83,1.51,1.51,0,0,0-.21.3A15.08,15.08,0,0,1,52.79,342,12.9,12.9,0,0,1,67,343.8a8.68,8.68,0,0,1,2.8,4,4.41,4.41,0,0,1-1.24,4.72,3.24,3.24,0,0,1-2.51.59,2.65,2.65,0,0,1-2-1.7,6.37,6.37,0,0,1,.65-5.72,8.91,8.91,0,0,1,4.94-3.8,15.8,15.8,0,0,1,6.66-.63,11,11,0,0,1,6.3,2.56,6.78,6.78,0,0,1,2.13,6.31,4.46,4.46,0,0,1-1.86,2.75A2.29,2.29,0,0,1,80,352.7a3.74,3.74,0,0,1-1-3,5.69,5.69,0,0,1,1.2-3A11.69,11.69,0,0,1,85.62,343a14.55,14.55,0,0,1,6.35-.82,8.46,8.46,0,0,1,5.34,2.57,6.6,6.6,0,0,1,1.92,5.14c-.14,1.76-1.48,3.47-3.1,3.58a2.58,2.58,0,0,1-2.07-.94,4.3,4.3,0,0,1-1-2.1,6.07,6.07,0,0,1,1-4.24A8.31,8.31,0,0,1,97,343.45a10.29,10.29,0,0,1,6.33-1,19.82,19.82,0,0,1,4,1A14.2,14.2,0,0,0,108.7,343.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.7,
    y: 414.08,
    width: 22.18,
    height: 83.21,
    transform: "translate(542.47 368.9) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.63,
    y: 301.15,
    width: 20.74,
    height: 55.86,
    transform: "translate(409.08 249.09) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.93,318.19a2.85,2.85,0,0,0,.88-.67,9.67,9.67,0,0,0,1.86-2.42A11.39,11.39,0,0,0,84,310.77a11,11,0,0,0-.9-5.47c-.78-1.81-1.74-3.39-2.3-4.94a7.63,7.63,0,0,1-.53-4.22,4.87,4.87,0,0,1,1.32-2.53c.49-.49.86-.65.83-.7a1.89,1.89,0,0,0-1,.51A4.78,4.78,0,0,0,79.85,296a7.78,7.78,0,0,0,.41,4.52c.56,1.63,1.52,3.23,2.27,5a10.89,10.89,0,0,1,.9,5.18,11.53,11.53,0,0,1-1.16,4.17A17.58,17.58,0,0,1,79.93,318.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.45,318.66a3,3,0,0,0,.89-.67,9.44,9.44,0,0,0,1.85-2.42,11.39,11.39,0,0,0,1.35-4.33,11.09,11.09,0,0,0-.9-5.48c-.78-1.81-1.74-3.38-2.31-4.93a7.71,7.71,0,0,1-.52-4.22,4.9,4.9,0,0,1,1.32-2.54c.49-.49.86-.64.83-.69s-.42.05-1,.51a4.85,4.85,0,0,0-1.59,2.62,7.8,7.8,0,0,0,.42,4.52c.56,1.62,1.52,3.23,2.27,5a10.87,10.87,0,0,1,.9,5.18,11.53,11.53,0,0,1-1.16,4.17A17.19,17.19,0,0,1,85.45,318.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.56,318.32c.18,0,.32-5.72.32-12.76s-.14-12.75-.32-12.75-.31,5.71-.31,12.75S67.39,318.32,67.56,318.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.07,327.71s-.2.09-.38.4a2.27,2.27,0,0,0-.21,1.51,2.56,2.56,0,0,0,1.36,1.83,2.55,2.55,0,0,0,3.24-3.36,2.56,2.56,0,0,0-1.88-1.29,2.3,2.3,0,0,0-1.5.26c-.31.19-.41.38-.39.4a3,3,0,0,1,1.8-.22,2.16,2.16,0,0,1,1.45,1.1,2,2,0,0,1-2.48,2.58,2.18,2.18,0,0,1-1.16-1.4A3,3,0,0,1,61.07,327.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.34,329.05c0-.17-7.83-.31-17.49-.31s-17.49.14-17.49.31,7.83.32,17.49.32S102.34,329.23,102.34,329.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.04,
    y: 47.26,
    width: 90.7,
    height: 150.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.02,
    y: 47.26,
    width: 90.7,
    height: 150.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.88,
    y: 50.3,
    width: 82.97,
    height: 144.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.68,
    y: 69.02,
    width: 51.02,
    height: 106.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.68,137.9c-.12-10,8.84-19.68,18.7-21.07,4.7-.66,9.7.27,14.09-1.53,7.84-3.22,10.34-13.64,18.23-16.73l.36,77.06H389.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.61,376.26a32.4,32.4,0,0,0-13.87-4.77c-2.26-.23-4.74-.17-6.55,1.21a1.35,1.35,0,0,0-.68,1.19,1.44,1.44,0,0,0,.64.82c5.64,4.31,14.17,4.85,20.46,1.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.25,375.87A67.13,67.13,0,0,1,387.3,368a22.68,22.68,0,0,1-5.62-10.38,4.18,4.18,0,0,1,.45-3.47c7.13,5.57,12.74,12.78,14.12,21.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.53,376.21a32.27,32.27,0,0,1,.17-11.76,15.88,15.88,0,0,1,6.26-9.7c1.23,2.89.7,6.21-.17,9.22A44.63,44.63,0,0,1,396.58,377",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.53,388.74c-4.25.52-7.95,2.76-11.12,5.63a21.07,21.07,0,0,0-6.36,10.92c4.17-.26,7.7-3.2,10.26-6.49s4.34-6.91,7.16-10",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.05,390.75a27.45,27.45,0,0,1,3.16-25.94c2.42,8.61,1.53,18.33-3.16,25.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.29,401.76a19.81,19.81,0,0,0-19,10.91c-.23.47-.44,1.07-.12,1.49a1.44,1.44,0,0,0,1.25.37c3.74-.25,7.05-2.49,9.78-5s5.12-5.52,8.13-7.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,401.16a35.31,35.31,0,0,1-.36-19.73c.7-2.53,1.86-5.21,4.21-6.4a.65.65,0,0,1,1,.36,11.92,11.92,0,0,1,1,5.66,35.93,35.93,0,0,1-.89,5.73c-.74,3.5-1.13,7.26-3.05,10.28a19.7,19.7,0,0,0-1.22,2.26c-.37.77-.37,1-.7,1.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.46,404.8c-1.81-6.89.12-15.25,4.46-20.91.32-.41.75-.86,1.27-.81.8.07,1,1.14,1,1.94a37.66,37.66,0,0,1-6.7,19.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.67,406.31a30.44,30.44,0,0,0,25-5.07,20.12,20.12,0,0,0-13.51-1.66c-4.52,1-8.64,3.05-11.45,6.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.53,401.72c4.69-7.65,13.69-12.64,22.65-13.1-1,3.65-4,6.48-7.41,8.19A41.09,41.09,0,0,1,446.9,400c-1.45.28-3.43.59-4.37,1.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.93,379.44a65.8,65.8,0,0,0,2.9-13.27,22.12,22.12,0,0,0-2.64-13.12c-4.39,8.48-4.83,18.39-.39,26.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.69,372c5.12-9.31,15.58-16.75,26.16-17.8-4.08,10.17-15.21,18-26.16,17.8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.46,373.81c7.65,1.16,14.16,6,21.3,9a9.55,9.55,0,0,0,4.82.93,3.77,3.77,0,0,0,2.36-6.67,10.18,10.18,0,0,0-3.5-2.12c-7.78-3.24-16.12-3.32-24.32-1.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,379.17c1.73.49,2.32,1.39,3.69,2.56A39.82,39.82,0,0,0,465.88,390c.62.16,1.43.22,1.74-.34s-.08-1.08-.42-1.51a22.3,22.3,0,0,0-9.75-6.62c-3.73-1.39-7-3.06-11.41-2.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.05,346.79a30.55,30.55,0,0,0,23.43,8,1.64,1.64,0,0,0,1.07-.38c.59-.64-.12-1.63-.81-2.17-6.89-5.37-15.23-7.6-23.69-5.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,344.62a32.63,32.63,0,0,1,29.24-4.82,23.16,23.16,0,0,1-13.94,6.11,43.89,43.89,0,0,1-15.3-1.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.61,329.74c-.67-6.87-.23-12.3-.71-19.21,0-.55-.16-1.22-.67-1.42-.72-.27-1.32.61-1.56,1.34a22,22,0,0,0,2.93,19.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.12,330.5a40.28,40.28,0,0,0,11.39-11.07c2.25-3.08,4.15-6.77,3.64-10.54a10.85,10.85,0,0,0-8.22,4.08,22.82,22.82,0,0,0-4.19,8.42c-.91,3-1.55,6.14-2.62,9.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.31,327.39a91.8,91.8,0,0,0,28-16.53c-3.35-1.35-7.19-.54-10.53.81a33.2,33.2,0,0,0-17.65,15.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.27,334.27c5.17.56,10.43.93,15.56.07s9.82-2.84,14.54-4.83a1.66,1.66,0,0,0,1-.75,1.13,1.13,0,0,0-.35-1.24,3,3,0,0,0-1.24-.58c-5.13-1.44-10.66-.76-15.71.94a72.41,72.41,0,0,0-13.78,6.39",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.71,347c-3.53-7.12-3.3-15.44-.25-22.79,2.15,3.27,2.41,7.44,2,11.33s-1.58,7.91-1.66,11.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.61,339.91A31.78,31.78,0,0,0,380,350a22,22,0,0,0,12.93-2.4A65.41,65.41,0,0,0,404,340.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.13,336.74c-4.32-.35-8.47-.89-12.61.38a15.15,15.15,0,0,0-9.61,8.15A22.69,22.69,0,0,0,383.73,343a67.76,67.76,0,0,0,10.4-6.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.17,336.88c-3.88-2.54-7.87-5.13-12.38-6.18s-9.76-.28-12.91,3.13c3.66,2.14,8.1,2.4,12.34,2.39s9.43-.05,13.43,1.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.19,337.09c-6.63-6.52-9.15-18.22-6.48-27.12a41.34,41.34,0,0,1,6.48,27.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.43,318.63c1.25-2.9,2.13-6,3.25-8.92a25.59,25.59,0,0,1,4.64-8.22,12.22,12.22,0,0,1,8.21-4.26,33.1,33.1,0,0,1-15.94,21.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.13,322.48c-2.07-2.85-4.46-6.72-7.27-8.85S409.4,310.22,406,311a23,23,0,0,0,17.16,11.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.79,318.87a48.51,48.51,0,0,1-3.27-10.6,16.54,16.54,0,0,1,1.65-10.77c3.65,6.88,4.82,14.27,1.8,21.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.46,297.5c2.06-6.82,8.31-11.85,15.06-14.15a5.59,5.59,0,0,1,2.64-.4,2.31,2.31,0,0,1,1.94,1.63c.25,1.16-.71,2.2-1.61,3a51.3,51.3,0,0,1-18,9.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.54,291.92c.26-4.4.53-8.86,2-13s4.19-8.08,8.2-9.9c.69,4.44-1.27,8.86-3.64,12.68s-5.21,7.44-6.63,11.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.43,295c-1.71-5-1.88-11.29-4.86-15.62-2.08-3-5.41-5.09-7.21-8.3a12.66,12.66,0,0,0,.42,9.42,27.58,27.58,0,0,0,5.51,7.89c2.2,2.35,4.09,4.12,6.14,6.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.46,441.38c-.13,0-.25-33.17-.26-74.08s.1-74.09.23-74.09.25,33.17.25,74.09S426.59,441.38,426.46,441.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.45,342a7.19,7.19,0,0,1-1.25.47l-3.43,1.15c-2.9,1-6.87,2.42-11.19,4.19s-8.3,3.32-10.59,5.3a7.8,7.8,0,0,0-2.13,2.82c-.33.78-.39,1.26-.43,1.25s0-.12,0-.35a5.53,5.53,0,0,1,.25-1,7.6,7.6,0,0,1,2.07-3,18.5,18.5,0,0,1,4.6-2.85c1.84-.86,3.88-1.76,6-2.65,4.33-1.77,8.34-3.15,11.26-4.06,1.47-.45,2.66-.79,3.49-1A7,7,0,0,1,455.45,342Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465,318.68a2.17,2.17,0,0,1-.35.37l-1.06,1-4,3.61-13.22,11.78c-5.17,4.59-9.63,9-12.72,12.29-1.55,1.65-2.77,3-3.6,4l-1,1.1a2.22,2.22,0,0,1-.36.37,2.41,2.41,0,0,1,.29-.43c.2-.27.49-.66.89-1.16.79-1,2-2.39,3.49-4.08A168.86,168.86,0,0,1,446,335.08c5.18-4.58,9.89-8.7,13.32-11.67l4.07-3.5,1.13-.93A2.2,2.2,0,0,1,465,318.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.76,340.11c-.13-.06.95-2.55,2-5.7s1.6-5.81,1.73-5.78a19.41,19.41,0,0,1-1.27,5.94,40.33,40.33,0,0,1-1.61,4A5.87,5.87,0,0,1,440.76,340.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.49,360.19a5.38,5.38,0,0,1-.79-.93c-.54-.69-1.23-1.56-2-2.61-1.71-2.21-4.08-5.27-6.73-8.61s-5.1-6.34-6.86-8.51L408,337a5.44,5.44,0,0,1-.72-1,6,6,0,0,1,.86.86c.53.58,1.28,1.42,2.2,2.48,1.83,2.12,4.31,5.09,7,8.43s5,6.44,6.63,8.71c.82,1.13,1.48,2.06,1.92,2.7A5.47,5.47,0,0,1,426.49,360.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.14,352a11.69,11.69,0,0,1-2.67-5,14.32,14.32,0,0,1-.6-5l.21,0c-.09.38-.16.58-.2.58s0-.22,0-.62l.21,0a23.68,23.68,0,0,0,.85,4.89A35.84,35.84,0,0,0,420.14,352Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.93,341.71a8.36,8.36,0,0,0-1.86-1.08,12.36,12.36,0,0,0-5.16-.41,31,31,0,0,0-5.2.84,15.5,15.5,0,0,1-2.14.51,7.37,7.37,0,0,1,2.05-.84,23.62,23.62,0,0,1,5.25-1,11.31,11.31,0,0,1,5.33.57A3.33,3.33,0,0,1,411.93,341.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,339.21c0,.07-1.09-.44-2.85-1a28.86,28.86,0,0,0-14.36-1.1c-1.83.33-2.94.68-3,.6a2.56,2.56,0,0,1,.76-.32,16.65,16.65,0,0,1,2.15-.61,25.38,25.38,0,0,1,14.53,1.11,20.08,20.08,0,0,1,2,.92A2.81,2.81,0,0,1,410,339.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.43,328.63a58.76,58.76,0,0,1-2.08-7.22,58.27,58.27,0,0,1-1.61-7.33,58.91,58.91,0,0,1,2.08,7.21A60,60,0,0,1,426.43,328.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.56,328.63a34,34,0,0,0-2.3-4.32,18.74,18.74,0,0,0-3.39-3.5,3.24,3.24,0,0,1,1.31.68,10.52,10.52,0,0,1,2.47,2.54A9.55,9.55,0,0,1,426.56,328.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.46,423.7s-.15-.8-.52-2.21a31.37,31.37,0,0,0-2.22-5.74c-2.29-4.69-6.46-10.62-11.76-16.57-2.62-3-5.17-5.83-7.33-8.54a59.3,59.3,0,0,1-5.25-7.57,36.73,36.73,0,0,1-2.65-5.61c-.24-.69-.42-1.23-.52-1.61a2.37,2.37,0,0,1-.13-.57s.28.76.83,2.11a40.39,40.39,0,0,0,2.76,5.51,63.84,63.84,0,0,0,5.3,7.46c2.17,2.68,4.72,5.5,7.35,8.5,5.32,6,9.48,12,11.71,16.74a28.94,28.94,0,0,1,2.09,5.85,14.67,14.67,0,0,1,.29,1.66A2.36,2.36,0,0,1,426.46,423.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.65,394.11a10.17,10.17,0,0,1-1.37.77,30.44,30.44,0,0,0-3.56,2.36,40.07,40.07,0,0,0-4.67,4.26c-1.65,1.73-3.34,3.75-5.06,5.91-3.45,4.32-6.68,8.15-8.61,11.21-1,1.52-1.7,2.8-2.16,3.69a10.94,10.94,0,0,1-.76,1.39,1.53,1.53,0,0,1,.13-.39c.1-.25.24-.62.46-1.08a36,36,0,0,1,2-3.79,124.85,124.85,0,0,1,8.52-11.33c1.73-2.17,3.44-4.18,5.12-5.92a38.36,38.36,0,0,1,4.79-4.23,24.11,24.11,0,0,1,3.68-2.24c.45-.23.82-.37,1.07-.48A1.73,1.73,0,0,1,452.65,394.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.17,403.71a20.93,20.93,0,0,1-2.9.42,38,38,0,0,0-6.89,1.36,20.66,20.66,0,0,0-6.16,3.23c-1.42,1.1-2.09,2-2.15,1.95s.11-.26.43-.67a11,11,0,0,1,1.51-1.54,18.48,18.48,0,0,1,6.23-3.43,31,31,0,0,1,7-1.24A16.16,16.16,0,0,1,453.17,403.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.91,409.62c-.15-.09,1.16-2.09,2.17-4.77s1.18-5.09,1.35-5.06a4.57,4.57,0,0,1-.05,1.55,16.63,16.63,0,0,1-.84,3.67,18,18,0,0,1-1.69,3.36A4.51,4.51,0,0,1,435.91,409.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.14,368.34a2.39,2.39,0,0,1-.47.25l-1.36.62c-.6.26-1.32.58-2.14,1s-1.78.86-2.77,1.46l-1.58.9c-.55.31-1.1.69-1.67,1.05-1.17.71-2.34,1.58-3.59,2.47a61.55,61.55,0,0,0-13.8,14.28c-.85,1.28-1.68,2.48-2.35,3.67-.34.59-.69,1.14-1,1.7l-.85,1.62c-.56,1-1,2-1.36,2.82s-.7,1.56-.93,2.17-.43,1-.58,1.38-.21.48-.23.47a4,4,0,0,1,.14-.5l.49-1.42c.21-.62.49-1.37.87-2.21s.75-1.83,1.3-2.87l.82-1.63c.29-.57.64-1.13,1-1.73.66-1.21,1.48-2.42,2.33-3.72a59.34,59.34,0,0,1,13.9-14.38c1.26-.89,2.45-1.76,3.63-2.46.59-.35,1.14-.72,1.7-1l1.61-.88c1-.58,2-1,2.82-1.4s1.57-.71,2.18-.94l1.4-.54A2.42,2.42,0,0,1,461.14,368.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.41,382.23a3.37,3.37,0,0,1,1.14-1.69,7.17,7.17,0,0,1,4.59-1.77,12.47,12.47,0,0,1,4.83,1,6.83,6.83,0,0,1,1.83.89,12.26,12.26,0,0,1-1.94-.57,14.61,14.61,0,0,0-4.7-.79,7.49,7.49,0,0,0-4.39,1.54A13.54,13.54,0,0,0,440.41,382.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.31,385.43a12.3,12.3,0,0,0,1-8.67,2.93,2.93,0,0,1,.54,1.23,8.59,8.59,0,0,1,.23,3.25,8.77,8.77,0,0,1-1,3.11C437.71,385.08,437.36,385.46,437.31,385.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.55,428.45c.72,12.68,4.54,25.57,10.41,38.6h25.55c5.61-12.9,9.16-25.78,9.79-38.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.16,449c0,.13-8.41.24-18.78.24s-18.79-.11-18.79-.24,8.41-.24,18.79-.24S445.16,448.83,445.16,449Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.59,453.55c0,.14-7.88.24-17.61.24s-17.61-.1-17.61-.24,7.88-.24,17.61-.24S444.59,453.42,444.59,453.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.37,436.77a72.27,72.27,0,0,1,0,11.77,72.27,72.27,0,0,1,0-11.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.06,436.77a77.51,77.51,0,0,1,0,12.19,77.51,77.51,0,0,1,0-12.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.92,436.67a80.59,80.59,0,0,1,0,12.43,80.59,80.59,0,0,1,0-12.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.49,436.77c0,.13-9.86.24-22,.24s-22-.11-22-.24,9.86-.24,22-.24S448.49,436.64,448.49,436.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.22 77.72 178.22 178.95 32.83 178.95 27.59 78.43 178.22 77.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.14,
    y: 55.89,
    width: 100.31,
    height: 145.39,
    transform: "translate(-28.29 228.87) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.68,179.43H26.9V77.74H173.68Zm-145.4-1.38h144V79.12h-144Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.34,
    y: 90.89,
    width: 113.9,
    height: 75.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.24,90.89s-.2,0-.56,0l-1.62,0-6.26,0-23.47.09-82,.16.33-.33c0,23,0,48.55,0,75.38h0l-.36-.36,113.9.07-.29.29c.07-22.94.12-41.75.15-54.85,0-6.55.06-11.66.08-15.17,0-1.73,0-3.06,0-4s0-1.39,0-1.39,0,.44,0,1.33,0,2.22,0,3.93c0,3.49,0,8.58.08,15.1,0,13.14.08,32,.15,55v.28h-.29l-113.9.08H43v-.36h0c0-26.83,0-52.35,0-75.38v-.33h.33l82.21.16,23.39.09,6.19,0,1.59,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.59,78.15a11.66,11.66,0,0,1,2.5,1.62c1.49,1.07,3.52,2.59,5.7,4.34s4.11,3.41,5.47,4.65a12.24,12.24,0,0,1,2.08,2.13c-.13.15-3.63-2.73-8-6.21S27.47,78.31,27.59,78.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,78.43c.12.16-3.31,3.07-7.65,6.51s-8,6.11-8.1,6,3.3-3.07,7.65-6.51S172.86,78.27,173,78.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.87,178.75l-16.21-13.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.66,165.61c.13-.15,3.86,2.67,8.33,6.29s8,6.7,7.88,6.85-3.85-2.66-8.33-6.29S156.54,165.77,156.66,165.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.59,178.74c-.12-.16,3.27-3,7.57-6.45s7.9-6,8-5.88-3.27,3-7.57,6.45S27.72,178.89,27.59,178.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.68,
    y: 91.17,
    width: 25.24,
    height: 71.67,
    transform: "translate(-24.7 229.3) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.17,466.73c0,.14-96.34.26-215.16.26s-215.18-.12-215.18-.26,96.32-.26,215.18-.26S462.17,466.59,462.17,466.73Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.69,447.35S82.14,461,104.6,462s68.7,2.11,68.7,2.11l-2.9-29.33-72-5-11.5,8.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.7,
    y: 45.19,
    width: 246.36,
    height: 421.74,
    rx: 16,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.27,64.53H330.48a0,0,0,0,1,0,0V450.91a0,0,0,0,1,0,0h-214a5.21,5.21,0,0,1-5.21-5.21V64.53A0,0,0,0,1,111.27,64.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.41,55.32H195.53a2.8,2.8,0,0,1-2.8-2.8h0a2.8,2.8,0,0,1,2.8-2.8h46.88a2.8,2.8,0,0,1,2.8,2.8h0A2.8,2.8,0,0,1,242.41,55.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.16,105.81v2.75h-.22a3,3,0,0,0-1-1.65,2.44,2.44,0,0,0-1.59-.57,2.35,2.35,0,0,0-1.36.42,2.48,2.48,0,0,0-.91,1.12,5,5,0,0,0-.37,2,6.54,6.54,0,0,0,.27,1.94,2.6,2.6,0,0,0,.84,1.33,2.34,2.34,0,0,0,1.49.45,2.86,2.86,0,0,0,1.37-.33,4.8,4.8,0,0,0,1.32-1.13v.68a4.2,4.2,0,0,1-1.39,1,4.24,4.24,0,0,1-1.69.32,4.85,4.85,0,0,1-2.26-.51,3.62,3.62,0,0,1-1.53-1.47,4.13,4.13,0,0,1-.53-2,4.28,4.28,0,0,1,.59-2.16,4.21,4.21,0,0,1,1.61-1.58,4.39,4.39,0,0,1,2.15-.56,5,5,0,0,1,1.77.36,2.7,2.7,0,0,0,.68.21.46.46,0,0,0,.33-.13.81.81,0,0,0,.18-.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.46,106v3.17a3.24,3.24,0,0,1,.83-.67,1.68,1.68,0,0,1,.78-.2,1.34,1.34,0,0,1,.88.3,1.38,1.38,0,0,1,.49.69,5.07,5.07,0,0,1,.12,1.33v2.14a1.71,1.71,0,0,0,.11.78.72.72,0,0,0,.48.2v.21h-2.78v-.21a.64.64,0,0,0,.44-.24,1.56,1.56,0,0,0,.11-.74V110.3a3.53,3.53,0,0,0-.06-.85.5.5,0,0,0-.18-.27.45.45,0,0,0-.28-.1.77.77,0,0,0-.46.17,1.88,1.88,0,0,0-.48.56v2.94a1.76,1.76,0,0,0,.09.73.61.61,0,0,0,.46.25v.21h-2.78v-.21a.69.69,0,0,0,.49-.23,1.55,1.55,0,0,0,.1-.75v-5.57a1.66,1.66,0,0,0-.11-.77.72.72,0,0,0-.48-.2V106Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.92,113.13a2.89,2.89,0,0,1-1.8.88,1.06,1.06,0,0,1-1.09-1.08,1.5,1.5,0,0,1,.54-1.12,10.07,10.07,0,0,1,2.35-1.34v-.55a2.47,2.47,0,0,0-.07-.78.6.6,0,0,0-.25-.28.79.79,0,0,0-.42-.12,1.09,1.09,0,0,0-.63.17.3.3,0,0,0-.15.25.49.49,0,0,0,.16.3.74.74,0,0,1,.22.49.67.67,0,0,1-.21.49.8.8,0,0,1-.56.2.91.91,0,0,1-.62-.23.68.68,0,0,1-.25-.52,1.21,1.21,0,0,1,.34-.8,2.07,2.07,0,0,1,.93-.59,3.71,3.71,0,0,1,1.24-.21,2.09,2.09,0,0,1,1.24.33,1.59,1.59,0,0,1,.58.72,4.27,4.27,0,0,1,.09,1.13v2.13a2.11,2.11,0,0,0,0,.47.31.31,0,0,0,.08.15.23.23,0,0,0,.14,0c.1,0,.2-.07.31-.21l.17.14a2,2,0,0,1-.6.63,1.33,1.33,0,0,1-.71.19,1.11,1.11,0,0,1-.74-.22A1,1,0,0,1,151.92,113.13Zm0-.43v-1.83a3.28,3.28,0,0,0-1,.89,1,1,0,0,0-.23.64.66.66,0,0,0,.19.47.53.53,0,0,0,.41.16A1.12,1.12,0,0,0,151.92,112.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,113.38v2a1.47,1.47,0,0,0,.07.57.45.45,0,0,0,.2.23,1.63,1.63,0,0,0,.56.07v.21h-3.13v-.21a.74.74,0,0,0,.54-.21,1.23,1.23,0,0,0,.12-.7V109.6a1.29,1.29,0,0,0-.14-.74.72.72,0,0,0-.52-.19v-.21H157v.72a2,2,0,0,1,.59-.61,1.69,1.69,0,0,1,.93-.28,1.79,1.79,0,0,1,1.1.38,2.38,2.38,0,0,1,.75,1.06,4,4,0,0,1,.26,1.44,4.11,4.11,0,0,1-.27,1.52,2.29,2.29,0,0,1-.77,1,1.93,1.93,0,0,1-2,.16A2.11,2.11,0,0,1,157,113.38Zm0-.59a1.39,1.39,0,0,0,1.08.71.61.61,0,0,0,.52-.33,6,6,0,0,0,0-3.82.68.68,0,0,0-.6-.34c-.39,0-.72.28-1,.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,106.45v2h1.3V109h-1.3v3.38a2.56,2.56,0,0,0,0,.61.44.44,0,0,0,.15.22.37.37,0,0,0,.21.09c.25,0,.49-.19.72-.58l.18.13a1.6,1.6,0,0,1-1.54,1.12,1.34,1.34,0,0,1-.89-.29,1.31,1.31,0,0,1-.46-.64,5.88,5.88,0,0,1,0-1.08v-3h-.72v-.21a7.61,7.61,0,0,0,1.26-1.09,7.06,7.06,0,0,0,.9-1.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.21,111h-3a2.85,2.85,0,0,0,.58,1.72,1.23,1.23,0,0,0,1,.49,1.1,1.1,0,0,0,.63-.2,2.33,2.33,0,0,0,.62-.7l.2.13a3.35,3.35,0,0,1-1,1.28,2.12,2.12,0,0,1-1.24.38,2.07,2.07,0,0,1-1.85-.94,3.26,3.26,0,0,1-.5-1.87,3.07,3.07,0,0,1,.74-2.18,2.25,2.25,0,0,1,1.74-.82,1.88,1.88,0,0,1,1.44.69A3.09,3.09,0,0,1,170.21,111Zm-1.44-.39a5.28,5.28,0,0,0-.11-1.3,1,1,0,0,0-.31-.53.52.52,0,0,0-.33-.11.57.57,0,0,0-.5.3,2.58,2.58,0,0,0-.35,1.43v.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.17,108.46v1.24a4,4,0,0,1,1-1.13,1.49,1.49,0,0,1,.79-.28.69.69,0,0,1,.53.21.77.77,0,0,1,.19.57.89.89,0,0,1-.19.61.59.59,0,0,1-.46.21.79.79,0,0,1-.54-.2l-.26-.22a.32.32,0,0,0-.14,0,.47.47,0,0,0-.32.13,1.19,1.19,0,0,0-.36.56,3.87,3.87,0,0,0-.19,1.26V113a1.57,1.57,0,0,0,0,.42.43.43,0,0,0,.21.23,1.33,1.33,0,0,0,.47.1v.21h-3v-.21a.64.64,0,0,0,.48-.2,1.74,1.74,0,0,0,.13-.88v-3a2.34,2.34,0,0,0,0-.6.44.44,0,0,0-.17-.24.87.87,0,0,0-.39-.11v-.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.51,105.83v6.5a4.35,4.35,0,0,0,.06.93.61.61,0,0,0,.27.33,1.26,1.26,0,0,0,.66.13h.18v.22H179.5v-.22h.21a1.55,1.55,0,0,0,.72-.12.58.58,0,0,0,.3-.32,3.67,3.67,0,0,0,.07-1v-4.12a2.9,2.9,0,0,0-.05-.69.56.56,0,0,0-.2-.24.58.58,0,0,0-.33-.09,1.89,1.89,0,0,0-.72.18l-.11-.21,2.92-1.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.59,157.24v6.43H151a10.14,10.14,0,0,0-1.25-3.2,4.79,4.79,0,0,0-1.87-1.55,6,6,0,0,0-2.33-.32h-1.77v18.33a7.6,7.6,0,0,0,.2,2.27,1.83,1.83,0,0,0,.79.8,3.14,3.14,0,0,0,1.6.34h.79V181H134.68v-.65h.79a3.36,3.36,0,0,0,1.67-.36,1.71,1.71,0,0,0,.71-.84,7.1,7.1,0,0,0,.2-2.21V158.6h-1.72a5,5,0,0,0-3.49,1,6.78,6.78,0,0,0-1.92,4h-.67v-6.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.1,130.84c0,.15-9,.26-20.08.26s-20.08-.11-20.08-.26,9-.26,20.08-.26S305.1,130.7,305.1,130.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,162.07c0,.14-32.77.26-73.19.26s-73.19-.12-73.19-.26,32.76-.26,73.19-.26S304.64,161.92,304.64,162.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,172.13c0,.15-32.77.26-73.19.26s-73.19-.11-73.19-.26,32.76-.26,73.19-.26S304.64,172,304.64,172.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,182.2c0,.15-32.77.26-73.19.26s-73.19-.11-73.19-.26,32.76-.26,73.19-.26S304.64,182.06,304.64,182.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,192.27c0,.14-39.33.26-87.84.26s-87.84-.12-87.84-.26,39.32-.26,87.84-.26S304.64,192.13,304.64,192.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,202.34c0,.14-39.33.26-87.84.26s-87.84-.12-87.84-.26,39.32-.26,87.84-.26S304.64,202.19,304.64,202.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.89,212.41c0,.14-22.15.26-49.46.26s-49.47-.12-49.47-.26,22.14-.27,49.47-.27S227.89,212.26,227.89,212.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,222.47c0,.15-39.33.26-87.84.26s-87.84-.11-87.84-.26,39.32-.26,87.84-.26S304.64,222.33,304.64,222.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,232.54c0,.14-39.33.26-87.84.26s-87.84-.12-87.84-.26,39.32-.26,87.84-.26S304.64,232.4,304.64,232.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,242.61c0,.14-39.33.26-87.84.26s-87.84-.12-87.84-.26,39.32-.26,87.84-.26S304.64,242.46,304.64,242.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,252.68c0,.14-39.33.26-87.84.26s-87.84-.12-87.84-.26,39.32-.26,87.84-.26S304.64,252.53,304.64,252.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,262.74c0,.15-39.33.26-87.84.26s-87.84-.11-87.84-.26,39.32-.26,87.84-.26S304.64,262.6,304.64,262.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.26,272.81c0,.15-6.56.26-14.65.26S129,273,129,272.81s6.55-.26,14.65-.26S158.26,272.67,158.26,272.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,282.88c0,.14-39.33.26-87.84.26S129,283,129,282.88s39.32-.26,87.84-.26S304.64,282.74,304.64,282.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,293c0,.14-39.33.26-87.84.26S129,293.09,129,293s39.32-.26,87.84-.26S304.64,292.8,304.64,293Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,303c0,.15-39.33.26-87.84.26S129,303.16,129,303s39.32-.26,87.84-.26S304.64,302.87,304.64,303Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.82,313.08c0,.15-30.19.26-67.43.26s-67.43-.11-67.43-.26,30.18-.26,67.43-.26S263.82,312.94,263.82,313.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,323.15c0,.14-39.33.26-87.84.26s-87.84-.12-87.84-.26,39.32-.26,87.84-.26S304.64,323,304.64,323.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,333.22c0,.14-39.33.26-87.84.26s-87.84-.12-87.84-.26,39.32-.26,87.84-.26S304.64,333.07,304.64,333.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,343.29c0,.14-34,.26-76,.26s-76-.12-76-.26,34-.27,76-.27S281,343.14,281,343.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,353.35c0,.15-39.33.26-87.84.26S129,353.5,129,353.35s39.32-.26,87.84-.26S304.64,353.21,304.64,353.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,373.49c0,.14-39.33.26-87.84.26s-87.84-.12-87.84-.26,39.32-.26,87.84-.26S304.64,373.34,304.64,373.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,383.56c0,.14-39.33.26-87.84.26S129,383.7,129,383.56s39.32-.26,87.84-.26S304.64,383.41,304.64,383.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,393.62c0,.15-39.33.26-87.84.26s-87.84-.11-87.84-.26,39.32-.26,87.84-.26S304.64,393.48,304.64,393.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3,423.33l-.56,1.53h-4.68v-.22a20.39,20.39,0,0,0,2.91-3.08,3.9,3.9,0,0,0,.84-2.18,1.74,1.74,0,0,0-.46-1.25,1.49,1.49,0,0,0-1.11-.48,1.71,1.71,0,0,0-1.05.34,2,2,0,0,0-.69,1h-.21a2.66,2.66,0,0,1,.75-1.67,2.08,2.08,0,0,1,1.51-.58,2.26,2.26,0,0,1,1.62.62,2,2,0,0,1,.64,1.47,2.77,2.77,0,0,1-.28,1.2,7.66,7.66,0,0,1-1.4,2c-1,1.07-1.58,1.71-1.83,1.93h2.08a5.77,5.77,0,0,0,.89-.05,1.25,1.25,0,0,0,.46-.19,1.31,1.31,0,0,0,.35-.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.23,420.93a6.16,6.16,0,0,1,.41-2.34,3.36,3.36,0,0,1,1.09-1.46,1.87,1.87,0,0,1,1.09-.38,2.07,2.07,0,0,1,1.64.93,4.92,4.92,0,0,1,.91,3.13,6.08,6.08,0,0,1-.4,2.35,3,3,0,0,1-1,1.4,2,2,0,0,1-1.2.44,2.21,2.21,0,0,1-1.89-1.34A5.51,5.51,0,0,1,223.23,420.93Zm1.15.15a7.44,7.44,0,0,0,.41,2.68q.33.87,1,.87a1,1,0,0,0,.66-.28,1.82,1.82,0,0,0,.51-1,11.64,11.64,0,0,0,.27-2.85,7.65,7.65,0,0,0-.28-2.26,2.06,2.06,0,0,0-.54-1,.92.92,0,0,0-1.29.17,3,3,0,0,0-.58,1.52A14.59,14.59,0,0,0,224.38,421.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,449.93c-7.44-12.69-23.16-12.83-28.32-2.58V73.62A13.86,13.86,0,0,1,96.54,59.75c4.37-.56,8.34,1.11,15.1,5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,449.93c0-2.75-.72-169.69-1.63-385.16l.13.22a70.69,70.69,0,0,0-6.35-3.33,17.36,17.36,0,0,0-7-1.76,13,13,0,0,0-7,2.1,13.72,13.72,0,0,0-4.85,5.55,14.66,14.66,0,0,0-1.18,3.72,22.15,22.15,0,0,0-.2,3.92q0,4,0,7.92v46.72q0,30.63,0,59.67c0,38.64,0,74.87,0,107.77,0,65.8-.09,118.26-.11,150.08l-.2-.05a13.12,13.12,0,0,1,5.5-5.67A14.53,14.53,0,0,1,96.84,440a17.34,17.34,0,0,1,3.11.25c.49.09,1,.24,1.43.35a8.27,8.27,0,0,1,1.33.43,14.76,14.76,0,0,1,2.37,1.07l1.06.59c.32.21.63.44.93.66a10.8,10.8,0,0,1,1.62,1.29c.47.45.93.84,1.31,1.25a27.3,27.3,0,0,1,1.77,2.17c.79,1.22,1.15,1.76,1.24,1.91l-1.28-1.87c-.42-.64-1.08-1.3-1.79-2.16-.38-.4-.84-.79-1.31-1.23a13,13,0,0,0-1.63-1.28c-.3-.21-.6-.44-.92-.65l-1.06-.57a14.63,14.63,0,0,0-2.36-1.06,7.81,7.81,0,0,0-1.32-.41c-.46-.11-.93-.25-1.41-.35a18.19,18.19,0,0,0-3.09-.23,14.39,14.39,0,0,0-6.65,1.67,12.85,12.85,0,0,0-5.4,5.6l-.2.4v-.44c0-31.82-.06-84.28-.11-150.08,0-32.9,0-69.13,0-107.77q0-29,0-59.67v-31q0-7.83,0-15.74V75.19a22.58,22.58,0,0,1,.22-4,15.08,15.08,0,0,1,1.22-3.86,14.26,14.26,0,0,1,5-5.76,13.51,13.51,0,0,1,7.25-2.18,18,18,0,0,1,7.22,1.8c2.24,1,4.33,2.19,6.39,3.36l.13.08v.15C112.52,280.24,113,447.18,113,449.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.41,273.31a.47.47,0,0,1-.39-.2.5.5,0,0,1,.09-.7l5.68-4.3-5.64-3.58a.49.49,0,0,1-.16-.69.5.5,0,0,1,.69-.16l6.25,4a.47.47,0,0,1,.23.4.49.49,0,0,1-.19.42l-6.25,4.74A.5.5,0,0,1,315.41,273.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.87,64.53v46.12a1.08,1.08,0,0,0,1.84.76l11.11-11.11a1.09,1.09,0,0,1,1.53,0l11.1,11.11a1.08,1.08,0,0,0,1.85-.76V64.53Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M272.53,64.53v41.86a1.08,1.08,0,0,0,1.85.76l11.11-11.1a1.06,1.06,0,0,1,1.52,0l11.11,11.1a1.08,1.08,0,0,0,1.85-.76V64.53Z",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.72,128.35c.2-3.56,2.38-5.74,5.45-7.56a11.12,11.12,0,0,1,10.25-.46c2.15,1,4,2.77,6.39,3.07,3.89.5,7.57-3.1,11.39-2.2a5.06,5.06,0,0,1-.37,9.92c2.54.37,4,3.59,3,6s-3.61,3.78-6.18,3.84a14.29,14.29,0,0,1-7.28-2.29c-2.22-1.29-4.3-2.85-6.62-4a11,11,0,0,0-7.48-1.09c-3.36.89-5.75,4.07-6.63,7.44s-.5,6.93,0,10.38,1.19,6.92.86,10.39a1.27,1.27,0,0,1-.48,1.07c-.52.28-1.11-.21-1.49-.66A50.92,50.92,0,0,1,354,144.82c-1.18-3.69-1.83-7.29-.42-10.89s6.17-7.05,9.16-5.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.44,145.53l5.69,35.11c1.06,6.56,5.32,12.9,15.62,10.74h0c8.78-2.54,8.13-8.86,7-16.65h0s9.66-2.52,8.8-12.35c-.42-4.75-2.08-14.47-3.68-23.24a18.38,18.38,0,0,0-19.93-15l-.95.09C361.83,125.89,357.53,135.42,359.44,145.53Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.74,174.73a23.89,23.89,0,0,1-13.17-2.5s3.86,7.31,13.56,5.44Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.93,149a1.41,1.41,0,0,1-1.21,1.55,1.34,1.34,0,0,1-1.57-1.12,1.41,1.41,0,0,1,1.21-1.55A1.35,1.35,0,0,1,390.93,149Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.23,144.17c-.15.2-1.29-.48-2.8-.32s-2.54,1-2.72.85.05-.42.5-.82a3.9,3.9,0,0,1,2.15-.91,3.71,3.71,0,0,1,2.26.49C391.12,143.77,391.31,144.08,391.23,144.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.62,150.33a1.41,1.41,0,0,1-1.21,1.55,1.34,1.34,0,0,1-1.57-1.12,1.41,1.41,0,0,1,1.2-1.55A1.35,1.35,0,0,1,377.62,150.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.43,146c-.16.2-1.3-.48-2.81-.33s-2.54,1-2.72.86.06-.42.5-.82a3.86,3.86,0,0,1,2.16-.91,3.71,3.71,0,0,1,2.26.48C376.31,145.54,376.51,145.86,376.43,146Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,156.59a9.35,9.35,0,0,1,2.41-.69c.38-.08.73-.19.77-.46a1.93,1.93,0,0,0-.37-1.12l-1.43-2.82c-2-4-3.5-7.34-3.33-7.42s1.91,3.12,3.92,7.14l1.38,2.84a2.28,2.28,0,0,1,.36,1.49,1,1,0,0,1-.58.63,2.6,2.6,0,0,1-.65.15A10.19,10.19,0,0,1,383,156.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.22,140c-.1.43-1.63.39-3.38.78s-3.13,1-3.4.67c-.13-.16.08-.57.62-1a5.88,5.88,0,0,1,2.46-1.15,5.76,5.76,0,0,1,2.71.05C375.91,139.5,376.27,139.79,376.22,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.24,139.86c-.23.37-1.31.12-2.56.23s-2.28.46-2.56.13c-.13-.16,0-.52.43-.9a3.57,3.57,0,0,1,2-.77,3.52,3.52,0,0,1,2.11.49C390.16,139.35,390.34,139.68,390.24,139.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,152.72c-.17-.06-7-1.32-6.06,5.37s7.43,4.42,7.41,4.22S361,152.72,361,152.72Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.94,160.05s-.1.1-.29.21a1.16,1.16,0,0,1-.87.14A2.94,2.94,0,0,1,357.1,158a4,4,0,0,1,.11-1.71,1.37,1.37,0,0,1,.76-1,.61.61,0,0,1,.73.23c.11.18.09.32.12.32s.13-.13,0-.4a.7.7,0,0,0-.32-.38.89.89,0,0,0-.67-.09,1.67,1.67,0,0,0-1.08,1.2,4.07,4.07,0,0,0-.15,1.92,3.08,3.08,0,0,0,2.08,2.67,1.3,1.3,0,0,0,1-.32C360,160.21,360,160.06,359.94,160.05Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.06,130a13,13,0,0,0-4.6-4.34,22,22,0,0,0-13.15-3.26,17.88,17.88,0,0,0-12,6,18.94,18.94,0,0,0-4.22,10,27.89,27.89,0,0,0,1,10.89,8.4,8.4,0,0,0,2.27,4.2c.76.65,2,1,2.73.32a2.74,2.74,0,0,0,.63-1.63c.77-5.31,1.48-11-.92-15.81a15.56,15.56,0,0,1,4.2-4.71,8,8,0,0,1,6-1.45c3.09.62,5.23,3.35,7.82,5.13a14.24,14.24,0,0,0,12.88,1.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.36,160.66a6.94,6.94,0,0,1-.5,1.85,2.27,2.27,0,0,1-1.39,1.24,2.05,2.05,0,0,1-1.87-.56,3.29,3.29,0,0,1-.86-1.82c-.1-.61,0-1.38.61-1.58a1.63,1.63,0,0,1,.76,0l3.41.62",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.64,163.51a4.55,4.55,0,0,1-1.72.15,2.46,2.46,0,0,1-1.51-.89,2.62,2.62,0,0,1-.47-2.05,2,2,0,0,1,.18-.53c.09-.15.07-.14.21-.15s.36.06.55.09l.56.1c.73.14,1.39.25,1.94.33a5.8,5.8,0,0,0,1.82.16,5.58,5.58,0,0,0-1.74-.56l-1.92-.44-.56-.13a5.51,5.51,0,0,0-.62-.11.74.74,0,0,0-.46.11.77.77,0,0,0-.29.35,2.53,2.53,0,0,0-.23.67,3,3,0,0,0,.62,2.49,2.78,2.78,0,0,0,1.87,1,2.58,2.58,0,0,0,1.37-.23C383.54,163.68,383.66,163.54,383.64,163.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.44,122.57a1.71,1.71,0,0,1,.13.44,4.35,4.35,0,0,1,.05,1.32,6.18,6.18,0,0,1-2.43,4.11,9.18,9.18,0,0,1-6.93,1.42c-2.72-.37-5.44-1.68-8.28-2.85s-5.75-2-8.36-1.48a10.61,10.61,0,0,0-6,3.42,14.31,14.31,0,0,0-2.55,4c-.42,1-.57,1.65-.62,1.64a2.48,2.48,0,0,1,.09-.45,10.74,10.74,0,0,1,.38-1.25,13.24,13.24,0,0,1,2.47-4.14,10.72,10.72,0,0,1,6.13-3.6c2.73-.52,5.75.29,8.6,1.47s5.53,2.47,8.17,2.85a8.89,8.89,0,0,0,6.68-1.27,6.14,6.14,0,0,0,2.45-3.89A7.24,7.24,0,0,0,398.44,122.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.5,143a4.84,4.84,0,0,1,.26-1.85,11.7,11.7,0,0,1,2-4,11.88,11.88,0,0,1,1.74-1.79,4.31,4.31,0,0,1,1.84-1,2.21,2.21,0,0,1,1.4.15c.3.16.41.31.39.33a2.59,2.59,0,0,0-1.72-.18,7.58,7.58,0,0,0-3.3,2.72,13.44,13.44,0,0,0-2.08,3.85C354.68,142.26,354.57,143,354.5,143Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.27,148.74a5.56,5.56,0,0,1,.38-1.84,12.61,12.61,0,0,1,2.24-4,12.39,12.39,0,0,1,3.5-2.9,5.45,5.45,0,0,1,1.75-.7c0,.07-.63.36-1.59,1a14.28,14.28,0,0,0-5.61,6.7A15.18,15.18,0,0,1,356.27,148.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.75,424l15.32,20.14,7.52,19.43a2.6,2.6,0,0,0,3.52,1.41h0a2.58,2.58,0,0,0,1.45-1.88c.95-5.26,4.36-24.65,3.16-26.06-1.4-1.64-14.75-22.32-14.75-22.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.11,465l3.6-29.33.63.87a3.88,3.88,0,0,1,.74,2.59c-.19,2.48-.87,9.29-3.46,23.95a2.6,2.6,0,0,1-1.51,1.92Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.72,432.11a1.56,1.56,0,0,0,.85,1.91,1.49,1.49,0,0,0,1.9-.83,1.66,1.66,0,0,0-.91-2,1.56,1.56,0,0,0-1.88,1.09",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.3,452.65a5.6,5.6,0,0,0-5.64,1c-.05,0,.09-.38.52-.8a4.14,4.14,0,0,1,2.08-1,4.08,4.08,0,0,1,2.29.26C440.09,452.32,440.34,452.6,440.3,452.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.83,456.45a20.88,20.88,0,0,0-2.45.44c-1.29.44-2.06,1.3-2.19,1.19s.54-1.21,2-1.72A2.89,2.89,0,0,1,440.83,456.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.47,447.17a24.11,24.11,0,0,0-3.83.41,25.84,25.84,0,0,0-3.56,1.5,7.07,7.07,0,0,1,7.39-1.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.32,440.65c0,.17-1.44.51-2.95,1.53s-2.42,2.21-2.56,2.12a6.47,6.47,0,0,1,5.51-3.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,434.63a12.18,12.18,0,0,0-3.12,1.5,12.5,12.5,0,0,0-2.22,2.66c-.07,0,0-.44.25-1.06a5.61,5.61,0,0,1,4-3.12C431.56,434.49,432,434.56,432,434.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.07,435s-.27-.22-.59-.75a6.66,6.66,0,0,1-.86-2.48,3,3,0,0,1,.2-1.88,1,1,0,0,1,1.09-.5,1.69,1.69,0,0,1,1,.69,3.66,3.66,0,0,1-.61,4.63,4.27,4.27,0,0,1-4.69.65,1.49,1.49,0,0,1-.77-.95,1,1,0,0,1,.55-1.07,3.62,3.62,0,0,1,1.85-.28,7.63,7.63,0,0,1,2.56.58,2.39,2.39,0,0,1,.83.48,12.07,12.07,0,0,0-3.4-.66,3.29,3.29,0,0,0-1.61.28.54.54,0,0,0-.3.58,1,1,0,0,0,.55.59,3.76,3.76,0,0,0,4.05-.61,3.18,3.18,0,0,0,.58-3.92,1.18,1.18,0,0,0-.68-.51.55.55,0,0,0-.6.27,2.67,2.67,0,0,0-.2,1.59A9.53,9.53,0,0,0,428.07,435Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.33,433.66l-3,20.42s19.89,8.39,19.7,12.22l-39.93-2.87,3.34-32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.23,451a1.64,1.64,0,0,0-1.32,1.74,1.57,1.57,0,0,0,1.7,1.33,1.74,1.74,0,0,0,1.4-1.85,1.64,1.64,0,0,0-1.93-1.18",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.12,463.43l.34-3.23,38.46,4.12a2.74,2.74,0,0,1,1.31,2.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399,453.94c0,.2-1,.18-2,.7s-1.62,1.28-1.79,1.18.24-1.18,1.49-1.79S399.08,453.77,399,453.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,456.13c0,.19-.86.43-1.6,1.18s-1,1.6-1.23,1.57-.2-1.15.75-2.06S403,455.94,403,456.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.82,461.38c-.18,0-.34-1,.27-2s1.57-1.34,1.64-1.17-.56.68-1.06,1.52S405,461.38,404.82,461.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.18,449.22c-.1.17-1-.2-2.07-.25s-2,.21-2.08,0,.81-.78,2.11-.71S399.29,449.07,399.18,449.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "400.73 437.7 400.21 441.34 380.67 439.02 381.01 435.73 400.73 437.7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M399.7,445.09a3.83,3.83,0,0,1-2-.23,8.79,8.79,0,0,1-2-.87,9.77,9.77,0,0,1-1.08-.73,2.31,2.31,0,0,1-.55-.54.86.86,0,0,1,0-1,1.08,1.08,0,0,1,.9-.35,2.77,2.77,0,0,1,.74.18,7.69,7.69,0,0,1,1.19.56,7.39,7.39,0,0,1,1.71,1.41c.83,1,1.06,1.72,1,1.75s-.48-.6-1.34-1.41a7.9,7.9,0,0,0-1.67-1.2,8.48,8.48,0,0,0-1.1-.48c-.41-.15-.77-.2-.9,0s-.05.09,0,.23a2.23,2.23,0,0,0,.41.39,10.05,10.05,0,0,0,1,.71,11.26,11.26,0,0,0,1.85.95A13.26,13.26,0,0,1,399.7,445.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.42,445.34a3.22,3.22,0,0,1-.31-2,6.39,6.39,0,0,1,.51-2.16,6,6,0,0,1,.64-1.15,1.64,1.64,0,0,1,1.38-.87.94.94,0,0,1,.77.65,2.71,2.71,0,0,1,.12.75,4.15,4.15,0,0,1-.14,1.34,4.58,4.58,0,0,1-1.08,2c-.89.95-1.73,1.09-1.73,1s.66-.4,1.36-1.33a4.63,4.63,0,0,0,.84-1.8,4,4,0,0,0,.09-1.16c0-.43-.14-.79-.3-.76s-.57.26-.77.58a6.39,6.39,0,0,0-.61,1,7.46,7.46,0,0,0-.61,2C399.4,444.57,399.53,445.32,399.42,445.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.79,263.77s9.42,18.07,9.42,32.69c0,3.09-19.12,156.47-19.12,156.47l-27-2.28,13.12-141.71-4.25-28.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.54,279.78s6.32,52.81,9.29,73.16c3.11,21.3,9.21,25.32,9.21,25.32L426,446.45l17.72-15.71L397.25,361s-9.84-83.27-9.44-81.21S353.54,279.78,353.54,279.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,379.14a3.45,3.45,0,0,0,.45.66l1.4,1.8,5.13,6.61,16.77,22c6.53,8.58,12.49,16.33,16.9,21.86,2.2,2.77,4,5,5.28,6.5l1.47,1.74a5.13,5.13,0,0,0,.54.58,3.46,3.46,0,0,0-.46-.65c-.35-.46-.81-1.06-1.39-1.8L414,431.78c-4.33-5.66-10.24-13.4-16.77-22S384.7,393.5,380.29,388c-2.2-2.77-4-5-5.28-6.51l-1.47-1.73A4.85,4.85,0,0,0,373,379.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.34,310.7a.73.73,0,0,0,0,.24l.06.7q.09,1,.27,2.7c.26,2.38.62,5.76,1.08,9.91,1,8.4,2.3,19.93,3.76,32.67.17,1.4.33,2.79.49,4.09v.07l0,.05,16.7,25.06c2.11,3.14,3.82,5.67,5,7.46.58.85,1.05,1.51,1.38,2l.37.52c.09.11.13.17.14.16a.78.78,0,0,0-.1-.19l-.33-.54-1.3-2.05L414,386l-16.57-25.16,0,.11c-.15-1.31-.32-2.7-.48-4.1-1.53-12.73-2.91-24.26-3.91-32.65-.53-4.15-.95-7.52-1.25-9.9-.15-1.13-.27-2-.36-2.68-.05-.28-.08-.51-.11-.7S391.35,310.69,391.34,310.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M356,299.78s21,5.53,35.36,3.23c20.31-3.23,31.42-12.52,31.42-12.52l-1.81-5.8L355.13,293Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M389,179.8l16,4.6s9.45,67.28,11.79,77.1c2.94,12.31,6.25,22,6,25.46,0,0-7.29,9.67-28.78,12.2S352,295.68,352,295.68l-1.76-40.37s-9.92-36.14-10.13-42.17c-.54-14.82,3.06-23.45,3.06-23.45l21.4-9.59C370.53,186.76,385.82,189,389,179.8Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.67,196.74A23,23,0,0,0,405,184.4l1.37,33.82,8.84,11.05-8.84,6,14.85,19.27s14.23-6.68,14.86-12.68S421,202,418.67,196.74Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.92,234l-3.62,12.57c12.49,14.81,46.9,7.94,46.9,7.94l-13.69-19.34C400.41,237.52,377.92,234,377.92,234Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.87,232.21s-6.42-12.65-7.11-12.8-10.79-3.7-10.79-3.7a3.64,3.64,0,0,0,0,2.54l-3.62.46s.54,2.24,1.77,2.55l-1.31,1.15a7.26,7.26,0,0,0,2.47,2.09,2.7,2.7,0,0,0,2.39,0s-.47.84,1.61,2.15,6.28,7.39,6.28,7.39Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.29,218.29a44.88,44.88,0,0,0,6.61,2.58c.92.33,1.84.58,2.56.92a3.52,3.52,0,0,1,1.51,1.44c.6,1.09.83,1.88.92,1.84a4.74,4.74,0,0,0-.58-2,3.66,3.66,0,0,0-1.62-1.71,24.06,24.06,0,0,0-2.61-1A46.62,46.62,0,0,0,357.29,218.29Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.94,221.26a5.1,5.1,0,0,0,1.82.67c1.16.31,2.79.57,4.52,1a11.73,11.73,0,0,1,4.09,1.92c.92.72,1.33,1.34,1.41,1.29a3.43,3.43,0,0,0-1.16-1.58,10.1,10.1,0,0,0-4.19-2.16c-1.78-.48-3.42-.68-4.59-.89A10.31,10.31,0,0,0,354.94,221.26Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.19,226.59a5.83,5.83,0,0,0-5.33-1.9c0,.16,1.27.25,2.73.78S364.09,226.72,364.19,226.59Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.06,189.86c4.57,1.12,5.92,6.49,9.08,17.23s6.63,21.8,6.63,21.8l1.79,5.15,39.8-9.61,8.05,12.75s-25.88,20.56-44.49,21.38c-9.06-.84-15-4.24-22.35-16.46-4.18-6.9-6.92-13.3-8.16-19.53-1.73-8.69-4.63-17.19-2.19-25.41C339.13,190.7,342.53,188.26,349.06,189.86Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.48,215.3a27.57,27.57,0,0,0-.85-5.36,26.49,26.49,0,0,0-1.39-5.25,28.52,28.52,0,0,0,.85,5.36A27,27,0,0,0,407.48,215.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M379.37,256.83a34.38,34.38,0,0,1,7.21-2.09c2.65-.4,4.88.39,7.53.8,7.91,1.24,13.81.3,21.27,0l.41,2.29c-3.28,2.56-7.41,3.38-11.58,3.3-3.77-.07-7.48-1.3-11.26-1.19a38.82,38.82,0,0,0-8.74,1.75A36.58,36.58,0,0,1,369.45,263c-12.37-1.86-17.14-11.59-19.2-16.12a37.66,37.66,0,0,0,3.42,4.68C361.54,259.73,372.84,259.58,379.37,256.83Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M415.79,237.29a1.37,1.37,0,0,1-.19.17l-.58.45c-.52.4-1.29,1-2.3,1.68-2,1.43-5,3.43-8.73,5.74a140.23,140.23,0,0,1-13.62,7.43c-1.32.62-2.67,1.27-4.1,1.82l-2.15.88c-.73.28-1.48.53-2.23.79a49.26,49.26,0,0,1-9.57,2.37,32.58,32.58,0,0,1-5,.13,18.48,18.48,0,0,1-4.76-1.13,23.51,23.51,0,0,1-7.69-5,47,47,0,0,1-8.95-12.66,74.29,74.29,0,0,1-4-9.65c-.4-1.17-.67-2.09-.84-2.72q-.1-.44-.18-.72a.66.66,0,0,1,0-.25.91.91,0,0,1,.09.24l.23.7c.21.62.51,1.52.93,2.68a79.81,79.81,0,0,0,4.15,9.56,47.43,47.43,0,0,0,8.95,12.47,23.1,23.1,0,0,0,7.54,4.89,17.48,17.48,0,0,0,4.63,1.09,31.27,31.27,0,0,0,4.92-.13,49.67,49.67,0,0,0,9.47-2.33l2.21-.78,2.14-.87c1.42-.55,2.77-1.18,4.09-1.79A149.08,149.08,0,0,0,403.8,245c3.77-2.27,6.76-4.22,8.8-5.6l2.36-1.59.61-.41C415.71,237.33,415.78,237.28,415.79,237.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.08,202.31a2.78,2.78,0,0,0,.14.65c.13.46.3,1.07.5,1.83l1.94,6.76c1.7,5.76,4,13.67,6.66,22.56l.07.23.26-.07c.93-.23,2-.46,3.1-.69,9.81-2.1,18.66-4.15,25-5.83,3.18-.82,5.74-1.57,7.5-2.1l2-.65a4.74,4.74,0,0,0,.69-.25,3.07,3.07,0,0,0-.72.16l-2,.55c-1.78.47-4.35,1.16-7.54,1.94-6.37,1.59-15.23,3.58-25,5.68-1.09.24-2.11.45-3.17.72l.33.16L360,211.45c-.87-2.81-1.58-5.08-2.09-6.71-.24-.75-.44-1.35-.59-1.81A2.86,2.86,0,0,0,357.08,202.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.72,234.2l17.09-.31a4,4,0,0,0,3.7-2.74l10-30.28c.75-2.28-.93-4.13-3.63-4.28l-20.92-1.18c-3.36,0-5.15,1.05-5.72,3l-6.53,23.85C410,227.76,412.78,234,417.72,234.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.57,222.66l2.73-5.79,5.05-1.42-1.61,5.33c1.76.86,4.09,1.41,5.61.57s7.49-6.77,8.62-6.2,2.13,1.93,1.1,3.23-6.62,5.34-5.47,6.53,7.6-4,9.49-3.65,3.05,1.49,2,2.3-3.65,3.4-4.11,4.54c.11,1.42.79,3.44.17,3.79a23,23,0,0,1-4.75,1.64c-.34,0-2.74,1-4.95,1.85a11,11,0,0,1-7.78.18l-1.28-.45a5,5,0,0,1-3.33-4.74l.05-4.27Z",
    style: {
      fill: "#ffbf9d"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbook);
export default __webpack_public_path__ + "static/media/Ebook.a2bcd96bf57dc5dc5b2702fc935a7a0b.svg";
export { ForwardRef as ReactComponent };